export const MAIN_TEXT_COLOR = '#F5F5F5';
export const SECOND_TEXT_COLOR = '#F5F5F5';
export const THIRD_TEXT_COLOR = '#F5F5F5';
export const FOURTH_TEXT_COLOR = '#B0AAB0';
export const BUTTON_SEE_MORE_TEXT_COLOR = '#337CD1';

export const MAIN_SITE_COLOR = '#35476B';
export const MAIN_BACKGROUND_COLOR =
  'linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(255, 255, 255, 0) 93.75%),linear-gradient(0deg, #121214, #121214);';
export const PROJECT_BACKGROUND_COLOR = '#6B7177';
